import { css } from 'emotion'

export const SendConfirmEmailButtonStyles = css`
  .SuccessMessage,
  .ErrorMessage {
    margin: 8px;
  }
`
